import { inject, Injectable } from '@angular/core';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private env = inject(EnvService);

  info = (message: any, ...params: Array<any>) => {
    if (typeof message !== 'string') {
      params = [message, ...params];
      message = '';
    }
    let args = ['%cINFO: ' + '%c' + message, 'color:#1db100', 'font-weight:800'];
    args = args.concat(params);
    console.log.apply(console.log, args);
  }

  debug = (message: any, ...params: Array<any>) => {
    if (this.env.isProduction) return;
    if (typeof message !== 'string') {
      params = [message, ...params];
      message = '';
    }
    let args = ['%cDEBUG: ' + '%c' + message, 'color:#3D88FE', 'font-weight:800'];
    args = args.concat(params);
    console.log.apply(console.log, args);
  }

  warn = (message: any, ...params: Array<any>) => {
    if (this.env.isProduction) return;
    if (typeof message !== 'string') {
      params = [message, ...params];
      message = '';
    }
    let args = ['%cWARN: ' + '%c' + message, 'color:#ffc107', 'font-weight:800'];
    args = args.concat(params);
    console.warn.apply(console.log, args);
  }

  error = (message: any, ...params: Array<any>) => {
    if (this.env.isProduction) return;
    if (typeof message !== 'string') {
      params = [message, ...params];
      message = '';
    }
    let args = ['%cERROR: ' + '%c' + message, 'color:#ee220c', 'font-weight:800'];
    args = args.concat(params);
    console.error.apply(console.log, args);
  }
}
